import { useEffect } from 'react'

export function PaypalPaymentCancelPage() {
  const closeWindow = () => {
    window.opener?.postMessage({ id: 'glows-paypal', success: false }, '*')
    window.close()
  }

  useEffect(() => {
    closeWindow()
  }, [])
  return <div>Canceled</div>
}
